import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ spacing, breakpoints }) =>
    createStyles({
        title: {
            textAlign: 'center',
            [breakpoints.down('sm')]: {
                fontSize: '26px'
            }
        },
        pagination: {
            display: 'flex', 
            justifyContent: 'center', 
            marginTop: '40px',
            marginBottom: '30px'
        },
        arrowBack: {
            color: 'black'
        }
    })
);